<template>
  <div class="card edit_ticket">
    <div class="header">
      <h4 class="title">
        {{ ticket_info.title }} /
        <span
          v-on:click.exact="router(ticket_info.device_fid, '_self')"
          v-on:click.ctrl="router(ticket_info.device_fid, '_blank')"
          style="cursor: pointer">
          {{ ticket_info.device_fid }}
        </span>
      </h4>
      <span class="badge" :class="this.ticket_status[this.ticket_info.status].color">
        {{ this.ticket_status[this.ticket_info.status].title }}
      </span>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6 col-xs-6">
          <fg-input
          v-model="ticket_info.device_fid"
          type="text"
          :label="translate('support.device')"
          readonly
          />
        </div>
        <div class="col-md-6 col-xs-6">
          <fg-input
          v-model="ticket_info.user_name"
          type="text"
          :label="translate('support.user')"
          readonly
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-6">
          <div class="form-group">
            <label>{{ translate('support.create') }}</label>
            <input class="input_text" type="text" name="" :value="get_date(ticket_info.ts_create)" readonly>
          </div>
        </div>
        <div class="col-md-6 col-xs-6">
          <div class="form-group">
            <label>{{ translate('support.update') }}</label>
            <input class="input_text" type="text" name="" :value="get_date(ticket_info.ts_update)" readonly>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-6">
          <sis-select
            v-model="ticket_info.executor_user_id"
            :options="executor_list"
            :placeholder="translate('support.executor')"
            :label="translate('support.executor')"
            :clearable="false"
            :searchable="false"
            @input="set_executor"
          />
        </div>
        <div class="col-md-6 col-xs-6">
          <sis-select
            v-model="new_status"
            :options="action_list"
            :placeholder="translate('support.status')"
            :label="translate('support.status')"
            :clearable="false"
            :searchable="false"
            @input="set_status"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ translate('support.message') }}</label>
            <div class="message_list" id="message_list">
              <div
              class="message"
              v-for="(msg, key) in ticket_info.data"
              :key="key"
              :class="{right : msg.owner, last_message : key === ticket_info.data.length - 1}"
              >
                <div class="message_header">
                  <span class="user">{{ msg.user_name }}</span>
                  <span class="time">{{ get_date(msg.ts_create) }}</span>
                </div>
                <div class="message_body">
                  <span>{{ msg.message }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div class="action_list">
              <div class="action"
                v-for="(action, key) in action_message"
                :key="key"
              >
                <div class="action_left">
                  <textarea v-if="action.text" class="input_text" type="text" name="" :data_input="action.action_name" v-model="action.value"></textarea>
                </div>
                <div class="action_right">
                  <button name="button" class="btn btn-success btn-fill" @click="send_answer(action, ticket_info.id)"> {{ action.action_name }} </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
          >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowTicket",
  props: ['ticket', 'check'],
  data () {
    return {
      ticket_info: {},
      old_url: '',
      leave: false,
      new_status: this.ticket.status,
      section: ''
    }
  },
  beforeMount(){
    this.ticket_info = {...this.ticket}
    this.section = this.$route.name
  },
  created(){
    this.init()
  },
  mounted () {
    this.scroll_bottom()
  },
  destroyed(){
    this.close_modal()
  },
  computed:{
    permissions(){
      return this.$store.getters.getPermissions
    },
    action_message(){
      let list = []
      for (let action of this.ticket_info.actions) {
        if (action.action_name === "Message") {
          list.push(action)
        }
      }
      return list
    },
    action_list(){
      let list = [{id: parseInt(this.ticket_info.status), label: this.ticket_status[this.ticket_info.status].title, isDisabled: true}]
      for (let action of this.ticket_info.actions) {
        if (action.action_name !== "Message") {
          list.push({id: parseInt(action.action_id), label: action.action_name})
        }
      }

      return list
    },
    executor_list(){
      let list = []
      for (let executor_id in this.$store.getters.getExecutorList) {
        list.push({id: parseInt(executor_id), label: this.$store.getters.getExecutorList[executor_id]})
      }
      return list
    },
    ticket_status () {
      return this.$store.getters.getTicketStatus
    },
  },
  watch:{
    ticket_info(){
      this.scroll_bottom()
    }
  },
  methods: {
    set_status(){
      if (this.new_status !== this.ticket_info.status) {
        this.$http.v1.actionAnswer({ticket_id: this.ticket_info.id, action_id: this.new_status}, (response) => {
          if (response.data.status) { // response status

            this.new_status = response.data.status // ticket status
            this.$emit('reload')
            this.ticket_info = response.data//data with ticket

            this.scroll_bottom() //прокрутка сообщения вниз
          }else{
            this.global_notify('danger', this.translate('support.new_ticket_error'))
          }
        })
      }


    },
    set_executor(){
      if (this.ticket_info.executor_user_id && this.ticket_info.executor_user_id !== this.ticket.executor_user_id) {
        this.$http.v1.setExecutorTicket({ticket_id: this.ticket_info.id, executor_user_id: this.ticket_info.executor_user_id}, (response) => {
          this.ticket_info = response.data.ticket
          this.$emit('reload')
        })
      }
    },
    cancel () {
      this.$emit('close')
    },
    init(){
      this.old_url = this.$route.fullPath
      if (!this.$route.params.support_id && !this.$route.params.to_zero) {
        history.pushState(null, null, window.location.href + '/' + this.ticket.id)
      }
    },
    close_modal () {
      if (this.$route.params.support_id || this.$route.params.to_zero) {
        let index = this.$route.params.support_id ? this.$route.params.support_id : this.$route.params.to_zero
        let new_window = this.$route.fullPath.replace('/'+ index, '')
        this.$router.push(new_window)
      }else if (this.section === this.$route.name){
        this.$router.push(this.old_url)
      }
    },
    scroll_bottom(){
      //чтобы скролл всегда находился внизу и показывалось последнее сообщение
      this.$nextTick(() => {
        let message_list = this.$el.querySelector("#message_list")
        message_list.scrollTop = message_list.scrollHeight;
      })
    },
    router(id, target){
      this.leave = true
      let routeData = this.$router.resolve({name: 'device/' + id})
      window.open(routeData.href + routeData.location.name, target)

      if (target === "_self") {
        this.$emit('close')
      }

    },
    send_answer(action, ticket_id){
      let answer = {
        'ticket_id': ticket_id,
        'action_id': action.action_id
      }
      if (action.value) {
        answer.text = action.value
      }
      this.$http.v1.actionAnswer(answer, (response) => {
        if (response.data.status) {
          this.ticket_info = response.data
          this.$emit('reload')

          this.scroll_bottom() //прокрутка сообщения вниз
          this.$el.querySelector("[data_input = "+action.action_name+"]").focus() //Определение input и фокус на него после отправки
        }else{
          this.global_notify('danger', this.translate('support.new_ticket_error')) //TODO add update_ticket_error
        }
      })

    }
  }
}
</script>
<style lang="scss" scoped>

  .edit_ticket {
    .header{
      display: flex;
      align-items: center;
      .title{
        margin-right: 5px;
      }
      .badge{
        color: white;
      }
    }
    .content{
      .input_text{
        width: 100%;
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
        &[readonly]{
          background-color: #E3E3E3;
          cursor: not-allowed;
          color: #66615b;
        }
      }

      .message_list{
        height: 300px;
        width: 100%;
        background-color: white;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        position: relative;
        padding: 10px;
        overflow-y: scroll;
        overflow-x: hidden;
        .message{
          position: relative;
          width: 100%;
          max-width: 70%;
          border: 1px solid #f5f5f5;
          background-color: #f5f5f5;
          border-radius: 4px;
          display: inline-block;
          padding: 10px;
          margin: 5px 0;
          float: left;
          z-index: 1;
          &::after, &::before {
            content: "";
            position: absolute;
            left: -25px;
            bottom: .5em;
            width: 1.8em;
            height: 1.8em;
            border: .5em solid white;
            border-radius: 50%;
            background: white;
            z-index: -1;
          }

          &::before {
            border-top: none;
            height: .9em;
            border-radius: 0 0 50% 50% / 0 0 100% 100%;
            background: #f5f5f5;
            border-color: #f5f5f5;
            margin-left: .9em;
          }

          &.right{
            float: right;
            background-color: #d5ffec;
            border-color: #d5ffec;
            &::after{
              left: 100.2%;
            }
            &::before {
              left: 100%;
              background: #d5ffec;
              border-color: #d5ffec;
              margin-left: -.9em;
            }
          }

          &:first-child{
            margin-top: 0;
          }

          &_header{
            .user{
              font-weight: bold;
              margin-right: 10px;
            }
          }
          &_body{
          }
        }
      }
      .action_list{
        .action{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          &_left{
            width: 69.5%;
            height: 60px;
            textarea{
              height: 100%;
              resize: none;
              outline: none;
            }
          }
          &_right{
            width: 29.5%;
            button{
              width: 100%;
              height: 60px;
              margin: 0;
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px){
    .edit_ticket .content .message_list{
      height: 170px;
    }
  }


</style>
